import { render, staticRenderFns } from "./PreciseDigitizingSummaryVertice.vue?vue&type=template&id=6f70e66d&scoped=true&"
import script from "./PreciseDigitizingSummaryVertice.vue?vue&type=script&lang=js&"
export * from "./PreciseDigitizingSummaryVertice.vue?vue&type=script&lang=js&"
import style0 from "./PreciseDigitizingSummaryVertice.vue?vue&type=style&index=0&id=6f70e66d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f70e66d",
  null
  
)

export default component.exports